export default {
  api: {
    apiVersion: '2023-08-01',
    projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID || '',
    dataset: process.env.NEXT_PUBLIC_SANITY_DATASET || '',
    useCdn: process.env.NEXT_PUBLIC_SANITY_USE_CDN || false,
    perspective: 'published',
  },
};
